export class Template {
  public description: string;
  public designerID: string;
  public executiveSummary: boolean = false;
  public id: number;
  public markup: string;
  public name: string;
  public notes: string;
  public ownerID: number;
  public ownerDesignerID: string;
  public selected: boolean;
  public universal: boolean = false;
  public libraryItem: boolean = false;
  public code: string;
  //public noTarget: boolean = false;
}
